"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OptionsSchema = exports.DeleteWorkleaseSchema = exports.RefreshWorkleaseSchema = exports.CreateWorkleaseSchema = exports.RefreshConfigSchema = exports.WorkleaseTypeSchema = void 0;
const zod_1 = require("zod");
const common_1 = require("./common");
const WorkleaseTypeIterable = ['create', 'refresh', 'delete'];
exports.WorkleaseTypeSchema = zod_1.z.enum(WorkleaseTypeIterable);
exports.RefreshConfigSchema = zod_1.z.object({
    refreshSource: common_1.RefreshSourceSchema,
});
exports.CreateWorkleaseSchema = zod_1.z.object({
    materializedViewConfigId: zod_1.z.string(),
    type: zod_1.z.literal('create'),
    config: zod_1.z.null(),
});
exports.RefreshWorkleaseSchema = zod_1.z.object({
    materializedViewConfigId: zod_1.z.string(),
    type: zod_1.z.literal('refresh'),
    config: exports.RefreshConfigSchema,
});
exports.DeleteWorkleaseSchema = zod_1.z.object({
    materializedViewConfigId: zod_1.z.string(),
    type: zod_1.z.literal('delete'),
    config: zod_1.z.null(),
});
exports.OptionsSchema = zod_1.z.union([
    exports.CreateWorkleaseSchema,
    exports.RefreshWorkleaseSchema,
    exports.DeleteWorkleaseSchema,
]);
//# sourceMappingURL=EvaluateWorklease.js.map